/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EntityClassificationViewModel } from './EntityClassificationViewModel';
import {
    EntityClassificationViewModelFromJSON,
    EntityClassificationViewModelFromJSONTyped,
    EntityClassificationViewModelToJSON,
} from './EntityClassificationViewModel';
import type { FinancialInformationViewModel } from './FinancialInformationViewModel';
import {
    FinancialInformationViewModelFromJSON,
    FinancialInformationViewModelFromJSONTyped,
    FinancialInformationViewModelToJSON,
} from './FinancialInformationViewModel';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { TaxDetailsViewModel } from './TaxDetailsViewModel';
import {
    TaxDetailsViewModelFromJSON,
    TaxDetailsViewModelFromJSONTyped,
    TaxDetailsViewModelToJSON,
} from './TaxDetailsViewModel';

/**
 * 
 * @export
 * @interface FinancialAndTaxDetailsViewModel
 */
export interface FinancialAndTaxDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {FinancialInformationViewModel}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    financialDetails?: FinancialInformationViewModel;
    /**
     * 
     * @type {TaxDetailsViewModel}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    taxDetails?: TaxDetailsViewModel;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    isUsCitizen?: IAPYESORNO;
    /**
     * 
     * @type {EntityClassificationViewModel}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    entityClassification?: EntityClassificationViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof FinancialAndTaxDetailsViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the FinancialAndTaxDetailsViewModel interface.
 */
export function instanceOfFinancialAndTaxDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "partyType" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function FinancialAndTaxDetailsViewModelFromJSON(json: any): FinancialAndTaxDetailsViewModel {
    return FinancialAndTaxDetailsViewModelFromJSONTyped(json, false);
}

export function FinancialAndTaxDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialAndTaxDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'financialDetails': !exists(json, 'FinancialDetails') ? undefined : FinancialInformationViewModelFromJSON(json['FinancialDetails']),
        'taxDetails': !exists(json, 'TaxDetails') ? undefined : TaxDetailsViewModelFromJSON(json['TaxDetails']),
        'isUsCitizen': !exists(json, 'IsUsCitizen') ? undefined : IAPYESORNOFromJSON(json['IsUsCitizen']),
        'entityClassification': !exists(json, 'EntityClassification') ? undefined : EntityClassificationViewModelFromJSON(json['EntityClassification']),
        'isComplete': json['IsComplete'],
    };
}

export function FinancialAndTaxDetailsViewModelToJSON(value?: FinancialAndTaxDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'FinancialDetails': FinancialInformationViewModelToJSON(value.financialDetails),
        'TaxDetails': TaxDetailsViewModelToJSON(value.taxDetails),
        'IsUsCitizen': IAPYESORNOToJSON(value.isUsCitizen),
        'EntityClassification': EntityClassificationViewModelToJSON(value.entityClassification),
        'IsComplete': value.isComplete,
    };
}

